import {ModalCopy_CurrentStep, ModalCopy_Type} from "../@const"
import Task from "../../../model2/task/task"
import {ModalCopy_Task_CopyOptionId} from "../components/copy-task/copy-task"
import {Copy_Manager} from "./manager"
import {ModalCopy_Params} from "../@types"

// const debug = "CopyTask_Manager"
const debug = false

export class CopyTask_Manager extends Copy_Manager {

    public taskToCopy           : Task
    public subTasks             : any[]     = []

    public redirectToCopy       : boolean
    public copyAsSubtask        : boolean   = false

    constructor(task: Task, params?: ModalCopy_Params) {
        super(ModalCopy_Type.TASK)

        this.taskToCopy     = task
        this.redirectToCopy = _.get(params, 'redirectToCopy', true)
    }

    init = async () => {
        const response = await gd.api.Task.getSubtasks(this.taskToCopy!.id).promise()
        this.subTasks = response.subTasks

        this.setCurrentStep(ModalCopy_CurrentStep.COPY_TASK)
    }

    get modalTitle():string {
        return 'Duplicate Task'
    }

    get showProjectAccess() {
        return true
    }

    get affectedTasksIds(): ID[] {
        return [this.taskToCopy.id]
    }

    async commitCopy(result: any) {
        if (result) this.result = result

        const taskToCopy = this.taskToCopy!

        const data: any = {
            toProjectId         : this.result.parentProject,
            title               : this.result.title,
            user                : this.result.user,

            copyDescription     : this.result.copyOptions.includes(ModalCopy_Task_CopyOptionId.DESCRIPTION),
            copyTags            : this.result.copyOptions.includes(ModalCopy_Task_CopyOptionId.TAGS),
            copyNotes           : this.result.copyOptions.includes(ModalCopy_Task_CopyOptionId.NOTES),
            copyCustomFields    : this.result.copyOptions.includes(ModalCopy_Task_CopyOptionId.CUSTOM_FIELDS),
            copyUsers           : this.result.copyOptions.includes(ModalCopy_Task_CopyOptionId.USERS),

            deadline            : taskToCopy.deadline ? moment(taskToCopy.deadline).format("YYYY-MM-DD") : null,
            planningStartDate   : taskToCopy.startDate ? moment(taskToCopy.startDate).format("YYYY-MM-DD") : null,
            planningEndDate     : taskToCopy.endDate ? moment(taskToCopy.endDate).format("YYYY-MM-DD") : null,

            copySubTasks: this.result.copyOptions.includes("copySubtasks") ? _.map(this.subTasks, (task: any)=>{
                return {
                    taskId              : task.id,
                    user                : task.assignedToUserId,
                    planningStartDate   : null,
                    planningEndDate     : null
                }
            }) : [],
        }

        // copy as subtask
        if (this.copyAsSubtask) {
            data.parentTaskId = taskToCopy.parentTaskId
        }

        const request = gd.api.Task.copyToProject(taskToCopy.id, data)

        request.done((response: any)=>{
            if (this.redirectToCopy) {
                gd.taskView.open(response.newTask.id)
            }

            this.onCopy?.()
            gd.modal.hide()
        })
    }
}